import { selectFetchStatus } from '../../../../store/forgetPassword/selectors';
import { resetPasswordThunk } from '../../../../store/forgetPassword/thunks';
import { setUsername } from '../../../../store/forgetPassword/slice';
import { useDispatch, useSelector } from '../../../../store/store';
import { TypographyLogo } from '../../../../assets/icons/common';
import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';
import { useState } from 'react';

function Username() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const fetchStatus = useSelector(selectFetchStatus);

    const next = () => {
        dispatch(setUsername(email));
        dispatch(resetPasswordThunk(email));
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo width={280} height={70} />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Forgot password</span>
            </div>
            <span className={styles.description}>Enter your verified email to receive a verification code.</span>
            <Input
                type='text'
                label='Email'
                onChange={setEmail}
                value={email}
            />
            <Button
                text='Continue'
                onClick={next}
                disabled={!email}
                className={styles.submit}
                loading={fetchStatus === 'Pending'}
            />
            <div className={styles.backToSignIn}>
                Back to <span onClick={() => navigate('/signin')}> Sign in</span>
            </div>
        </div>
    )
}

export default Username;
